export enum UserRole {
  Admin = 1,
  Viewer = 2,
  Manager = 3,
  Customer = 4
}

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.Admin]: 'Administrador',
  [UserRole.Viewer]: 'Visualizador',
  [UserRole.Manager]: 'Gerente',
  [UserRole.Customer]: 'Customer'
};

export const UserRoleDescriptions: Record<UserRole, string> = {
  [UserRole.Admin]: 'Acceso completo',
  [UserRole.Viewer]: 'Solo lectura',
  [UserRole.Manager]: 'Acceso limitado con permisos de gestión',
  [UserRole.Customer]: 'Usuario sin permisos administrativos, solo acceso a su propia cuenta'
};

export function getUserRoleLabel(role: UserRole | number): string {
  return UserRoleLabels[role as UserRole] || 'Desconocido';
}

export function getUserRoleDescription(role: UserRole | number): string {
  return UserRoleDescriptions[role as UserRole] || '';
}

